import { Link } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';
import VymoLogo from '../assets/VymoLogo';
import './Footer.scss';

const links = [
  {
    id: 1,
    title: 'Product',
    className: 'w-1/2 order-1 md:order-1',
    subLinks: [
      {
        id: 1,
        title: 'SalesIQ',
        link: '/sales-iq/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 2,
        title: 'EarnIQ',
        link: '/earn-iq/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 3,
        title: 'OnboardIQ',
        link: '/onboard-iq/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 4,
        title: 'CollectIQ',
        link: '/collect-iq/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 5,
        title: 'DMS',
        link: '/distribution-management-system/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 6,
        title: 'CMS',
        link: '/collection-management-system/',
        target: '_self',
        space: 'my-1'
      },
    ],
  },
  {
    id: 2,
    title: 'Solutions',
    className: 'w-1/2 order-2 md:order-2',
    subLinks: [
      {
        id: 1,
        title: 'Agency',
        link: '/agency/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 2,
        title: 'Bancassurance',
        link: '/bancassurance/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 3,
        title: 'Branch Banking',
        link: '/branch-banking/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 4,
        title: 'Unified Sales',
        link: '/unified-sales/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 5,
        title: 'Retail Lending',
        link: '/retail-lending/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 6,
        title: 'Collections',
        link: '/collections/',
        target: '_self',
        space: 'my-1'
      },
    ],
  },
  {
    id: 4,
    title: 'Features',
    className: 'w-1/2 order-4 md:order-3',
    dname: 'no-pointer',
    target: '_self',
    subLinks: [
      {
        id: 1,
        title: 'Lead Management',
        link: '/lead-management/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 2,
        title: 'Activity Management',
        link: '/activity-management/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 3,
        title: 'Partner Engagement',
        link: '/partner-management/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 4,
        title: 'Sales Engagement',
        link: '/sales-engagement/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 5,
        title: 'CRM Plus',
        link: '/crm-plus/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 6,
        title: 'Banking CRM',
        link: '/banking-crm/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 7,
        title: 'Insurance CRM',
        link: '/insurance-crm/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 8,
        title: 'Insurance Sales',
        link: '/insurance-sales-solutions/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 9,
        title: 'Banking Sales',
        link: '/banking-sales-solutions/',
        target: '_self',
        space: 'my-1'
      },
    ],
  },
  {
    id: 4,
    title: 'Company',
    className: 'w-1/2 order-4 md:order-3',
    dname: 'no-pointer',
    target: '_self',
    subLinks: [
      {
        id: 1,
        title: 'About Us',
        link: '/about-us/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 2,
        title: 'Why Vymo',
        link: '/why-vymo/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 3,
        title: 'Integrations',
        link: '/integrations/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 4,
        title: 'Partner with us',
        link: '/partner-with-vymo/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 5,
        title: 'Security',
        link: '/vymo-security/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 6,
        title: 'Careers',
        link: '/careers/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 7,
        title: 'Contact',
        link: '/contact-us/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 8,
        title: 'FAQs',
        link: '/vymo-faq/',
        target: '_self',
        space: 'my-1'
      },
    ],
  },
  {
    id: 5,
    title: 'Resources',
    className: 'w-1/2 order-5 md:order-5',
    subLinks: [
      {
        id: 1,
        title: 'Resource Center',
        link: 'https://vymo.com/resources/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 2,
        title: 'Vymo Blog',
        link: 'https://vymo.com/blog/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 3,
        title: 'Case Studies',
        link: '/case-studies/',
        target: '_self',
        space: 'my-1'
      },
      {
        id: 4,
        title: 'Press Releases',
        link: 'https://vymo.com/press/',
        target: '_self',
        space: 'my-1'
      },
    ],
  },
];
function Footer({ dark }) {
  return (
    <footer className={`main-footer font-secondary ${dark ? 'bg-darkblack' : 'bg-white'}`}>
      <div className="fluid-container md:-mt-[1px]">
        <div className="flex flex-wrap flex-row pt-5 md:pt-[0px] pb-2 md:pb-[75px] pl-1 md:pl-0 md:pr-0 gap-3 md:gap-5 md:-mt-3 justify-between w-full">
          <div className="flex flex-wrap flex-row pt-5 md:pt-[0px] pb-6 md:pb-[75px] md:pr-0 gap-3 md:gap-5 md:mt-3">
            <a href="/us/onboardiq/" className="text-16 text-white font-medium hover:underline underline-offset-4">Onboardiq</a>
            <a href="/us/engageiq-overview/" className="text-16 text-white font-medium hover:underline underline-offset-4">Engageiq</a>
            <a href="/us/customers/" className="text-16 text-white font-medium hover:underline underline-offset-4">Customers</a>
            <a href="/us/aboutus/" className="text-16 text-white font-medium hover:underline underline-offset-4">About Us</a>
            <a href="/us/vymo-security/" className="text-16 text-white font-medium hover:underline underline-offset-4">Security</a>
            <a href="https://vymo.com/us/resources/" className="text-16 text-white font-medium hover:underline underline-offset-4">Resources</a>
          </div>
          <div className="text-white mt-3 flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" version="1.1" id="Capa_1" width="16px" height="16px" viewBox="0 0 395.71 395.71"><g><path d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738   c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388   C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191   c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z"/></g></svg>
            <p className="pl-1 -mt-[5px]">440 N Wolfe Rd, Sunnyvale , CA 94085</p>
          </div>
        </div>
      </div>
      <div className="flex flex-row w-full justify-between flex-wrap pb-[0px] md:pb-[42px] md:pt-[38px] mt-3 md:mt-0 m-sp-tp bg-[#1c1c1f]">
        <div className="container flex flex-row w-full mx-auto justify-between flex-wrap md:mx-auto p-2 md:pt-0 md:pb-0">
            <div className="order-1 w-auto">
              <Link to="https://vymo.com/us">
                <VymoLogo dark={!dark} />
              </Link>
            </div>
            <div className={`order-3 md:order-2 w-full md:w-auto flex ${
                dark ? 'text-white' : 'text-black'
              } text-14 privacy-link-container justify-between py-5 mt-[36px] md:mt-0 md:py-0 items-center`}>
              <div className="opacity-50 md:ml-0">
              © {new Date().getFullYear()}  Vymo, Inc. <span className="m-hidden">All rights reserved.</span>
              </div>
              <a href="/us/vymo-privacy-policy" className="md:ml-4">
                Privacy
              </a>
              <a href="/us/vymo-terms-conditions" className="md:ml-4">
                Terms & Conditions
              </a>
            </div>
            <div className="order-2 md:order-3 w-auto flex flex-row">
              
              
              {/* <a href="https://www.youtube.com/@VymoInc" className="hover:opacity-80" target="_blank">
                <img
                  src="/img/icons/youtube.png"
                  alt="youtube icon"
                  width="30px"
                  height="30px"
                />
              </a> */}

              <a href="https://linkedin.com/company/vymo/" className="hover:opacity-80 ml-[11px]" target="_blank">
                <img
                  src="/img/icons/linkedin.png"
                  alt="linkedin icon"
                  width="30px"
                  height="30px"
                />
              </a>

              {/* <a href="https://twitter.com/getvymo" className="hover:opacity-80 ml-[11px]" target="_blank">
                <img
                  src="/img/icons/twitter.png"
                  alt="twitter icon"
                  width="30px"
                  height="30px"
                />
              </a>

              <a href="https://www.instagram.com/humans.of.vymo/" className="hover:opacity-80 ml-[11px]" target="_blank">
                <img
                  src="/img/icons/instagram.png"
                  alt="linkedin icon"
                  width="30px"
                  height="30px"
                />
              </a> */}

            </div>
          </div>
        </div>
    </footer>
  );
}
Footer.propTypes = {
  dark: PropTypes.bool,
};
Footer.defaultProps = {
  dark: true,
};
export default Footer;
